"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mockResult = mockResult;
var defaultLatency = 800;

function mockResult(result, error, delay) {
  return new Promise(function (resolve, reject) {
    setTimeout(function () {
      if (!error) {
        if (result === null || result === undefined) {
          // fetch-mock bug workaround
          // Note: in action SUCCESS the payload will be correctly null and not a string.
          resolve('null');
        } else {
          // serialize result to prevent passing reference to the mocked data
          resolve(result ? JSON.parse(JSON.stringify(result)) : result);
        }
      } else {
        reject(error);
      }
    }, delay || defaultLatency);
  });
}